export default `float i,g,e,s=2.,k;
    vec3 q;
    p=vec3(length(p.xy)-PI,atan(p.y,p.x)*PI,p.z);
    p.yz=mod(p.yz,4.)-2.;
    p=abs(p); q=p;
    for(int j=0;++j<5;)
      p=1.-abs(p-1.),
      p=-p*(k=max(3./dot(p,p),3.))+q, s*=k;
    return length(p.xz)/s;
  }`